import { IProgressAuditTrace } from "../../../features/progressAudit/progressAuditTracesSlice";

// Two executions overlap when one starts before the other finishes -
// classic interval intersection. If either trace never finished (still
// "started"), there isn't enough information to call it an overlap, so
// it's treated as not overlapping rather than guessed.
export const tracesOverlap = (a: IProgressAuditTrace, b: IProgressAuditTrace): boolean => {
  if (!a.finishedAt || !b.finishedAt) {
    return false;
  }
  const aStart = new Date(a.receivedAt).getTime();
  const aEnd = new Date(a.finishedAt).getTime();
  const bStart = new Date(b.receivedAt).getTime();
  const bEnd = new Date(b.finishedAt).getTime();
  return aStart < bEnd && bStart < aEnd;
};
